import { AllUserData } from "@core/models/allusersData";


export class storeAllUserDataAction {
    static readonly type = '[AllUserData] AllUserData';

    constructor(public payload:AllUserData[] ) {
    }
}